const style = {
  fontFamily: "sans-serif",
  // fontFamily: ["Oswald"].join(","),
  h1: {
    fontWeight: "700",
    // fontSize: "2em",
    letterSpacing: "-0.24px",
    // lineHeight: "40px",
    // fontFamily: "Oswald",
  },
  h2: {
    fontWeight: "700",
    // fontSize: "1.5em",
    letterSpacing: "-0.24px",
    // lineHeight: "36px",
    // fontFamily: "Oswald",
  },
  h3: {
    // fontFamily: "Oswald",
    fontStyle: "700",
    fontWeight: "700",
    // fontSize: "1.17",
    // lineHeight: "32px",
  },
  h4: {
    fontWeight: "700",
    // fontSize: "22px",
    letterSpacing: "-0.06px",
    // lineHeight: "30px",
    // fontFamily: "Oswald",
  },
  h5: {
    // fontFamily: "Oswald",
    fontWeight: "700",
    // fontSize: "22px",
    letterSpacing: "-0.05px",
    // lineHeight: "30px",
  },
  h6: {
    // fontFamily: "Oswald",
    fontWeight: "400",
    // fontSize: "20px",
    letterSpacing: "-0.05px",
    // lineHeight: "30px",
  },
  subtitle1: {
    // fontFamily: "Oswald",
    fontStyle: "normal",
    fontWeight: "700",
    // fontSize: "14px",
    // lineHeight: "26px",
  },
  subtitle2: {
    // fontFamily: "Oswald",
    fontStyle: "normal",
    fontWeight: "700",
    // fontSize: "12px",
    // lineHeight: "26px",
  },
  body1: {
    fontSize: "12px",
    // letterSpacing: "-0.05px",
    // fontFamily: "Serif",
    // fontWeight: "400",
    // lineHeight: "16px",
  },
  body2: {
    fontSize: "10px",
    fontWeight: "300"
    // fontFamily: "Serif",
    // fontWeight: "400",
    // fontSize: "10px",
    // lineHeight: "22px",
  },
  // button: {
  //   fontSize: "14px",
  // },
  // caption: {
  //   fontSize: "14px",
  //   letterSpacing: "0.3px",
  //   lineHeight: "14px",
  // },
};
export default style;
